import { useEffect, useState } from "react";

export const useDailyStats = ({ dailyStats, prevFrom }) => {
  const [athleteStatsState, setAthleteStatsState] = useState([]);

  // Add the new loaded athlete stats to the state
  // This happens when going back to previous months which don't have the athlete stats loaded
  useEffect(() => {
    if (prevFrom) {
      let newStatsState = Array.from(athleteStatsState);
      newStatsState = newStatsState.concat(dailyStats);
      setAthleteStatsState(newStatsState);
      return;
    }
    setAthleteStatsState(dailyStats);
  }, [dailyStats]);

  return { athleteStatsState };
};
